import { post } from '@/utils/request';

// #region ******** 送样检测 ********
// 预览、填充原始记录
export const reqOriWordFill = params => {
  return post(`/app/office/reqOriWordFillV1`, params);
};
// 预览、填充报告（不盖章）
export const reqReportWordFill = params => {
  return post(`/app/office/reqReportWordFill`, params);
};
// 填充报告（盖章）
export const reqReportSealWordFill = params => {
  return post(`/app/office/reqReportSealWordFill`, params);
};
// 填充报告（验证签章）
export const getReportSealWord = params => {
  return post(`/app/office/getReportSealWord`, params);
};
// 生成pdf
export const reqReportPdf = params => {
  return post(`/app/office/reqReportPdf`, params);
};
// #endregion **** 送样检测 ********

// #region ******** 现场检测 ********
// 预览、填充原始记录
export const reqTotOriWordFill = params => {
  return post(`/app/office/reqTotOriWordFill`, params);
};
// 预览、填充报告（不盖章）
export const reqTotReportWordFill = params => {
  return post(`/app/office/reqTotReportWordFill`, params);
};
// 预览、填充技术服务报告
export const reqTotProjectStageWordFill = params => {
  return post(`/app/office/reqTotProjectStageWordFill`, params);
};
// #endregion **** 现场检测 ********

// test
export const testAddTable = params => {
  return post(`/app/office/testAddTable`, params);
};

export const testOriWord = params => {
  return post(`/app/office/testOriWord`, params);
};

export const testAddSeal = params => {
  return post(`/app/office/testAddSeal`, params);
};
